import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',

    '& > :not(:last-child)': {
      marginBottom: '0.5rem'
    }
  },

  loading: {
    display: 'grid',
    rowGap: '0.5rem'
  },

  input: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '4px',

    '& .text': {
      width: '100%',
      maxWidth: '100%'
    },

    '& button': {
      marginLeft: '0.25rem',
      marginRight: '0px',
      fontSize: '0px'
    }
  },

  comments: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden auto',
    maxHeight: '160px'
  },

  comment: {
    '& > div': {
      margin: '0'
    },

    '& .MuiAvatar-root': {
      margin: '0'
    },

    // Content
    '& > div > div:nth-child(2) > div:first-child > div:first-child': {
      width: 'unset'
    },

    // Footer
    '& > div > div:nth-child(2) > div:nth-child(2)': {
      flexDirection: 'column',
      alignItems: 'flex-start',
      padding: '0'
    },

    // Time
    '& > div > div:nth-child(2) > div:nth-child(2) > div:first-child': {
      marginRight: '0',
      marginBottom: '5px'
    }
  }
}))

export default useStyles
